/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectRoamPlan from 'modules/me/select-roam-plan';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import { hasScheduledChanges } from 'state/current-roam/selectors';

// new
import AnnotatedSection from 'components/annotated-section';
import Button from 'components/button';

const EditPlan = (props) => {
    return (
        <Box>
            <DocumentHead title='Manage Roam Plan Billing - Tower Systems' />
            <Topbar title='Roam Plan' subTitle='Manage your Roam subscription' selected='roam'>
                <Button primary link='/dashboard/roam'>
                    View Subscription Details
                </Button>
            </Topbar>

            <Main padding='xxlarge'>
                <Stack space='xxlarge'>
                    <Box>
                        <Heading level='3'>Select a Roam plan</Heading>
                        <Text>
                        Retailer Roam is a tablet app-based POS extension to the Tower Systems Retailer 
                        POS software. The app runs on Apple iPad and Android based tablets. 
                        It can run connected over WiFi or any other network. It can also run disconnected, 
                        syncing when connected again to a network at a later time.
                        </Text>
                    </Box>
                    <Box>
                        <SelectRoamPlan />
                    </Box>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect(
    (state) => ({
        hasScheduledChanges: hasScheduledChanges(state),
    }),
    {},
)(EditPlan);
